import '../../admin/css/main.scss';

import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';
import i18n, {t} from './i18n/i18n.js';

// Require jquery plugins & extensions
import '../jquery-plugins.js';
import '../jquery-extensions.js';

// Require generic prototype extensions
import '../extensions.js';

import {apiUrl, wsUrl} from '../shared_utils/baseUrls';
import MessagePopupView from '../controls/MessagePopupView.js';
import Filter from '../controls/Filter.js';
import UrlBuilder from '../appHelpers/UrlBuilder.js';
import NTP from '../utils/NTP.js';
import AlertUI from '../appHelpers/Alert.js';
import PreventNavUtil from '../appHelpers/PreventNav.js';
import TableAutoSavingConfigUtil from '../appHelpers/TableAutoSavingConfig.js';
import axios from 'axios';
import Vue from 'vue';
import VueTimersMixin from '../extensions/VueTimersMixin.js';
import VueAjaxMixin from '../extensions/VueAjaxMixin.js';

// Require the main app namespace
import app from './App.js';

// Other stuff we use here
import Router from './routers/Router.js';
import MainNavView from './views/MainNav.js';
import SideNav from './views/SideNav.js';

Vue.mixin({
    data() {
        return {
            i18n: i18n,
            t: t,
        }
    }
});

Vue.mixin(VueTimersMixin).mixin(VueAjaxMixin);

app.AlertUI = new AlertUI(i18n);
app.PreventNavUtil = new PreventNavUtil(i18n, app.AlertUI);
app.TableAutoSavingConfigUtil = new TableAutoSavingConfigUtil(app);

// All of these should be extracted to separate importable functions

// showXhrError
(function () {

    app.showReqError = function (err) {
        if (axios.isCancel(err)) return;

        let statusCode = err.isAxiosError === true ?
            (err.response ? err.response.status : 0) : 0;

        let errorCode;
        try {
            errorCode = JSON.parse(err.response.data)['error'];
        } catch (e) {
        }
        errorCode = errorCode || err.code;

        let errorCodes = t('error_codes'),
            msg = errorCodes['default'];

        if (errorCode === 'authorization-error') {

            let location = '/admin/login';
            if (Backbone.history.getFragment()) {
                location += '?return_url=' + encodeURIComponent(Backbone.history.getFragment());
            }

            window.location = location;
            return;
        }

        if (err.message === 'Network Error') {
            errorCode = 'network-error';
        }

        if (errorCode && errorCodes[statusCode.toString() + '-' + errorCode]) {
            msg = errorCodes[statusCode.toString() + '-' + errorCode];
        } else if (errorCode && errorCodes[errorCode]) {
            msg = errorCodes[errorCode];
        } else if (errorCodes[statusCode.toString()]) {
            msg = errorCodes[statusCode.toString()];
        }

        new MessagePopupView({addClass: 'error', message: msg, queue: true}).show();

        return this;
    };

    app.showXhrError = function (xhr, error) {
        if (error === 'abort') return;

        let errorCode;
        try {
            errorCode = xhr.responseJSON ? xhr.responseJSON['error'] : JSON.parse(xhr.responseText)['error'];
        } catch (e) {
        }
        errorCode = errorCode || error;

        let errorCodes = t('error_codes'),
            msg = errorCodes['default'];

        if (errorCode === 'authorization-error') {

            let location = '/admin/login';
            if (Backbone.history.getFragment()) {
                location += '?return_url=' + encodeURIComponent(Backbone.history.getFragment());
            }

            window.location = location;
            return;
        }

        if (errorCode && errorCodes[xhr.status.toString() + '-' + errorCode]) {
            msg = errorCodes[xhr.status.toString() + '-' + errorCode];
        } else if (errorCode && errorCodes[errorCode]) {
            msg = errorCodes[errorCode];
        } else if (errorCodes[xhr.status.toString()]) {
            msg = errorCodes[xhr.status.toString()];
        }

        new MessagePopupView({addClass: 'error', message: msg, queue: true}).show();

        return this;
    };

    // Redirect to login if authorization is required, otherwise ignore the error

    app.handleXhrLoginRequired = function (xhr, error) {
        if (error === 'abort') return;

        let errorCode;
        try {
            errorCode = xhr.responseJSON ? xhr.responseJSON['error'] : JSON.parse(xhr.responseText)['error'];
        } catch (e) {
        }
        errorCode = errorCode || error;

        if (errorCode === 'authorization-error') {

            let location = '/admin/login';
            if (Backbone.history.getFragment()) {
                location += '?return_url=' + encodeURIComponent(Backbone.history.getFragment());
            }

            window.location = location;
            return;
        }

        return this;
    };

})();

// API urls - Temp until adding import to different files
app.apiUrl = apiUrl;
app.wsUrl = wsUrl;

(function(){
    let userSettings = {}, userSettingsDebouncedUpdates = {};
    app.setUserSettings = function (value) {
        userSettings = value || {};
        return this;
    };
    app.getUserSetting = function (key) {
        const conf = userSettings[key];
        if (conf) {
            return JSON.parse(conf);
        }
        return null;
    };
    app.setUserSetting = function (key, conf) {
        conf = JSON.stringify(conf);
        const oldConf = userSettings[key];
        if (conf !== oldConf) {
            userSettings[key] = conf;

            let debounced = userSettingsDebouncedUpdates[key];
            if (!debounced) {
                debounced = userSettingsDebouncedUpdates[key] = _.debounce(function () {
                    $.ajaxJsonPost(app.apiUrl('me/settings/' + encodeURIComponent(key)), { 'value': userSettings[key] || '' });
                }, 500);
            }

            // Debounce the settings update
            debounced();
        }
        return this;
    };
})();

// User details
(function (app) {

    let _userId = null,
        _userName = '',
        _firstName = '',
        _lastName = '',
        _gender = null,
        _externalId = '',
        _roles = [],
        _permissions = [],
        _permissionsMap = {};

    app.isLoggedIn = function () {
        return !!_userId;
    };

    app.setLoggedOut = function () {
        _userId = _gender = null;
        _userName = _firstName = _lastName = '';
        _roles = _permissions = [];
        _permissionsMap = {};
        return this;
    };

    app.setUserId = function (userId) {
        _userId = userId;
        return this;
    };
    app.getUserId = function () {
        return _userId;
    };

    app.getUsername = function () {
        return _userName;
    };

    app.setUsername = function (username) {
        _userName = username || '';
        return this;
    };

    app.getFirstName = function () {
        return _firstName;
    };

    app.setFirstName = function (firstName) {
        _firstName = firstName || '';
        return this;
    };

    app.getLastName = function () {
        return _lastName;
    };

    app.setLastName = function (lastName) {
        _lastName = lastName || '';
        return this;
    };

    app.getGender = function () {
        return _gender;
    };

    app.setGender = function (gender) {
        _gender = gender || '';
        return this;
    };

    app.setUserRoles = function (value) {
        _roles = value || [];
        return this;
    };

    app.getUserRoles = function () {
        return _roles.splice(0);
    };

    app.setUserPermissions = function (permissions) {
        _permissions = permissions || [];
        _permissionsMap = {};
        for (let i = 0, len = _permissions.length; i < len; i++) {
            _permissionsMap[_permissions[i]] = true;
        }
        return this;
    };

    app.hasPermission = function (perm) {
        return _permissionsMap[perm] === true;
    };

    app.hasAnyPermissionIn = function () {
        let perms = arguments;
        if (perms.length === 1 && perms[0].splice) {
            perms = perms[0];
        }
        for (let i = 0; i < perms.length; i++) {
            if (_permissionsMap[perms[i]] === true) return true;
        }
        return false;
    };

    app.doAfterLogin = function () {


        return this;
    };

})(app);

(function (app) {

    app.filterForContactField = function (key) {

        let def = {
            label: t('contact_fields', key),
        };

        switch (key) {
            case 'birthdate':
                def.type = Filter.FilterType.DATE;
                break;

            case 'gender':
                def.type = Filter.FilterType.MULTIOPTION;
                def.source = {
                    '': t('none'),
                    'male': t('genders.male'),
                    'female': t('genders.female'),
                };
                break;

            default:
                def.type = Filter.FilterType.TEXT;
                break;
        }

        return def;
    };

    app.filterForOrderField = function (key) {

        let def = {
            label: t('order_fields', key),
        };

        switch (key) {
            case 'birthdate':
                def.type = Filter.FilterType.DATE;
                break;

            case 'gender':
                def.type = Filter.FilterType.MULTIOPTION;
                def.source = {
                    '': t('none'),
                    'male': t('genders.male'),
                    'female': t('genders.female'),
                };
                break;

            default:
                def.type = Filter.FilterType.TEXT;
                break;
        }

        return def;
    };

})(app);

(function (app) {

    let mainNav = null,
        mainView = null,
        sideNav = null;

    app.setupMainNav = function () {

        if (!mainNav) {
            mainNav = new MainNavView()
                .render()
                .setLogo('/resources/admin/images/logo.png');
        }
        mainNav.$el.appendTo(document.body);

    };
    app.getMainNav = function () {
        return mainNav;
    };

    app.setMainView = function (view, detach) {
        if (view === mainView) return this;

        if (mainView) {
            if (typeof mainView.hasUnsavedChanges === 'function') {
                app.PreventNavUtil.setHasUnsavedChangedHandler(null);
            }

            if (detach) {
                mainView.$el.detach();
            } else {
                mainView.remove();
            }
        }

        mainView = view;

        if (mainView) {
            mainView.$el.appendTo(document.body);
            mainView.render();

            if (typeof mainView.hasUnsavedChanges === 'function') {
                app.PreventNavUtil.setHasUnsavedChangedHandler(mainView.hasUnsavedChanges.bind(mainView));
            }
        }

        return this;
    };

    app.getMainView = function () {
        return mainView;
    };

    app.enableSideNav = function () {
        $(document.body).removeClass('disable-side-nav');
        return this;
    };
    app.disableSideNav = function () {
        $(document.body).addClass('disable-side-nav');
        return this;
    };

    app.showSideNav = function () {

        if (!sideNav) {
            sideNav = new SideNav().render();
        }
        if (!sideNav.$el[0].parentNode) {
            sideNav.$el.appendTo(document.body);
        }
        sideNav.$el.show();

        return this;
    };
    app.hideSideNav = function () {
        if (sideNav) {
            sideNav.$el.hide();
        }
        return this;
    };
    app.getSideNav = function () {
        return sideNav;
    };

})(app);

app.Permissions = {
    admin: 'admin',
    representative: 'representative',

    edit_general_settings: 'edit_general_settings',

    delete_contact: 'delete_contact',

    delete_project: 'delete_project',
    edit_project: 'edit_project',
    new_project: 'new_project',

    delete_role: 'delete_role',
    edit_role: 'edit_role',
    new_role: 'new_role',

    delete_team: 'delete_team',
    edit_team: 'edit_team',
    new_team: 'new_team',

    delete_user: 'delete_user',
    edit_user: 'edit_user',
    new_user: 'new_user',
    import_users: 'import_users',

    delete_lead_provider: 'delete_lead_provider',
    edit_lead_provider: 'edit_lead_provider',
    new_lead_provider: 'new_lead_provider',

    leads: 'leads',
    assign_leads: 'assign_leads',
    delete_leads: 'delete_leads',

    recordings_client: 'recordings_client',
    recordings_admin: 'recordings_admin',
    recordings_stream: 'recordings_stream',

    reports_call_sessions: 'reports_call_sessions',
    reports_realtime_userinfo: 'reports_realtime_userinfo',
    reports_live_listening: 'reports_live_listening',
    reports_live_screen_monitor: 'reports_live_screen_monitor',
    reports_userinfo: 'reports_userinfo',
    reports_call_history: 'reports_call_history',
    reports_orders: 'reports_orders',
    reports_campaigns: 'reports_campaigns',

};

app.bootstrap = function () {

    //i18n.setActiveLanguageFromMetaTag();

    if (t('rtl')) {
        $(document.documentElement).addClass('rtl');
    } else {
        $(document.documentElement).addClass('ltr');
    }

    $('<div id="app-preloader"><div class="preload-spinner"><div></div><div></div><div></div><div></div><div></div></div></div>').appendTo(document.body);

    app.router = new Router();

    Backbone.history.on('route', function (fragment) {
        if (/^login/.test(fragment)) {
            app.disableSideNav();
        } else {
            app.enableSideNav();
        }
    });

    $.get(this.apiUrl('auth/login'))
        .always(() => {
            app.setupMainNav();
            app.showSideNav();
            $('#app-preloader').fadeOut();
        })
        .done(data => {
            app.setUserId(data['user_id'])
                .setUsername(data['username'])
                .setFirstName(data['first_name'])
                .setLastName(data['last_name'])
                .setGender(data['gender'])
                .setUserRoles(data['roles'])
                .setUserPermissions(data['permissions'])
                .setUserSettings(data['settings']);

            app.doAfterLogin();

            Backbone.history.start({root: '/admin/', pushState: true});

            app.getMainNav().render();
        })
        .fail(() => {

            Backbone.history.start({root: '/admin/', pushState: true, silent: true});
            Backbone.history.fragment = false; // Allow navigating to any URL after navigating in 'silent' mode

            if (/^login(\/|\?|$)/.test(Backbone.history.getFragment())) {
                Backbone.history.navigate(Backbone.history.getFragment(), {trigger: true});
            }
            else {
                let returnUrl = Backbone.history.getFragment();
                if (returnUrl === 'login') {
                    returnUrl = '';
                }
                Backbone.history.navigate(returnUrl ? '/login?return_url=' + returnUrl : '/login', true);
            }

        });

    Backbone.history.on('route', () => {

        let fragment = Backbone.history.fragment ? Backbone.history.getFragment() : '';
        if (/^management\/(projects|roles|teams|users|lead_providers|settings)|leads|reports($|\/.*)/.test(fragment)) {
            app.enableSideNav();
        } else {
            app.disableSideNav();
        }

    });
};

$(function () {

    // Start!
    app.bootstrap();

    // Start synchronizing with our NTP
    NTP.synchronize();

    setInterval(function () {
        NTP.synchronize();
    }, 60000);

});
